import { render, staticRenderFns } from "./TranppassBIAdministracaoPrincipal.vue?vue&type=template&id=479c1882&"
import script from "./TranppassBIAdministracaoPrincipal.vue?vue&type=script&lang=js&"
export * from "./TranppassBIAdministracaoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports